class onlineCourseController {
    constructor() {
      'ngInject';
        this.menu = [
            {
                link: 'auth.login',
                value: 'login',
                column: 'column-1'
            },
            {
                link: 'site.try_course',
                value: 'try_course',
                column: 'column-2'
            },
            {
                link: 'site.testimonials',
                value: 'testimonials',
                column: 'column-3'
            },
            {
                link: 'site.barbara_minto',
                value: 'barbara_minto',
                column: 'column-1'
            },
            {
                link: 'site.buy_course',
                value: 'buy_course',
                column: 'column-2'
            },
            {
                link: 'site.corporate-inquiry',
                value: 'corporate_inquiry',
                column: 'column-3'
            }
        ];

        this.barbara = this.menu[3];
    }
}

export default onlineCourseController;



// WEBPACK FOOTER //
// ./client/app/modules/site/onlineCourse/onlineCourse.controller.js